import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIResponse } from '@mommy/models/Comm.model';
import { Api } from '../api';
import { HANDLE_CACHE } from '../token.interceptor';
const fs = require('fs');

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  constructor(private api: Api) {
    console.log('Hello LookupService');
  }

  getAllLookup(force?: boolean): Promise<any> {
    const endpoint = `v1/codes/reference-codes/all-lookups`;

    return new Promise(async (resolve, reject) => {
      try {
        const context = new HttpContext();
        context.set(HANDLE_CACHE, force ? false : true);

        const result: APIResponse = (await this.api
          .get(endpoint, null, { context })
          .toPromise()) as any;
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        if (error.status !== 304) {
          console.error('getAllLookup error', error);
        }
        reject(error);
      }
    });
  }

  getAllLookupAtServer(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        // 先從檔案讀取, 若無, 則呼叫 api 取得 並儲存到檔案
        const filename = 'cache-all-lookups.json';
        const filepath = `./${filename}`;

        console.log('@Server: getAllLookupAtServer filepath', filepath);
        fs.readFile(filepath, 'utf8', async (err, data) => {
          if (err) {
            console.error('@Server: getAllLookupAtServer error', err);
            reject(err);
          }

          if (data) {
            const data_obj = JSON.parse(data);
            console.log(
              '@Server: getAllLookupAtServer got cache data, rows: ',
              data_obj?.length
            );
            resolve(data_obj);
          } else {
            console.log(
              '@Server: getAllLookupAtServer got no cache, call api to get data'
            );
            const new_data = await this.getAllLookup();
            fs.writeFile(filepath, JSON.stringify(new_data), (err) => {
              if (err) {
                console.error('@Server: getAllLookupAtServer error', err);
                reject(err);
              }

              console.log('@Server: getAllLookupAtServer save cache success');
              resolve(new_data);
            });
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  getByMetaCriteria(meta_type: string, meta_key: string): Promise<any> {
    const endpoint = `v1/codes/reference-codes/by-meta-criteria`;

    return new Promise(async (resolve, reject) => {
      try {
        const params: any = {};
        params.meta_type = meta_type;
        params.meta_key = meta_key;

        const result: APIResponse = (await this.api
          .post(endpoint, params)
          .toPromise()) as any;
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        if (error.status !== 304) {
          console.error('getAllLookup error', error);
        }
        reject(error);
      }
    });
  }
}
